import * as Sentry from '@sentry/react';
import rev from './revision.json';

Sentry.init({
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: rev.revision || import.meta.env.VITE_SENTRY_RELEASE,
  sendDefaultPii: true,
  ignoreErrors: [/^Hydration failed/i],
  beforeSend(event) {
    // Scrub out cookies from request data
    delete event.request?.cookies;
    delete event.request?.headers?.Cookie;
    delete event.request?.headers?.cookie;
    return event;
  },
});
